import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]

  connect() {
    // Select first tab by default
    if (this.tabTargets.length > 0) {
      this.select(this.tabTargets[0])
    }
  }

  change(event) {
    this.select(event.currentTarget)
  }

  select(selectedTab) {
    // Update tab states
    this.tabTargets.forEach((tab, index) => {
      const selected = tab === selectedTab
      const panel = this.panelTargets[index]
      
      // Update tab classes
      const selectedClasses = tab.dataset.selectedClasses?.split(" ") || []
      const unselectedClasses = tab.dataset.unselectedClasses?.split(" ") || []
      
      if (selected) {
        tab.classList.remove(...unselectedClasses)
        tab.classList.add(...selectedClasses)
        tab.setAttribute("aria-selected", "true")
        panel.classList.remove("hidden")
      } else {
        tab.classList.remove(...selectedClasses)
        tab.classList.add(...unselectedClasses)
        tab.setAttribute("aria-selected", "false")
        panel.classList.add("hidden")
      }
    })
  }
} 